// extracted by mini-css-extract-plugin
export var active = "_i6-2";
export var recordingDot = "_i6-1";
export var recordingIndicator = "_i6-0";